import React from 'react';
import { FiX } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { AnnouncementStyle } from 'api/announcements/models/AnnouncementStyle';
import { useAnnouncements } from './AnnouncementsProvider';
import { resolveAnnouncementColors } from './announcementStyleColors';
import { resolveTranslation } from './resolveTranslation';
import { sanitizeInline } from './sanitizeInline';
import { applyDateToken } from './applyDateToken';
import styles from './AnnouncementsBanner.module.scss';

const AnnouncementsBanner: React.FC = () => {
    const { visible, dismiss } = useAnnouncements();
    const { i18n } = useTranslation();

    if (!visible.length) {
        return <></>;
    }

    return (
        <div className={styles.stack}>
            {visible.map(announcement => {
                const colors = resolveAnnouncementColors(announcement.style as AnnouncementStyle, announcement.textColor, announcement.backgroundColor);
                const { title, message } = resolveTranslation(announcement.translations, i18n.language);
                return (
                    <div
                        key={announcement.id}
                        className={styles.banner}
                        style={{ color: colors.textColor, backgroundColor: colors.backgroundColor }}
                    >
                        <strong className={styles.title}>{title}</strong>
                        <span
                            className={styles.message}
                            dangerouslySetInnerHTML={{ __html: sanitizeInline(applyDateToken(message, announcement.eventAt)) }}
                        />
                        <button
                            type="button"
                            className={styles.close}
                            style={{ color: colors.textColor }}
                            onClick={() => dismiss(announcement.id)}
                            aria-label="close"
                        >
                            <FiX />
                        </button>
                    </div>
                );
            })}
        </div>
    );
};

export default AnnouncementsBanner;
